import {
  ON_SELECTED_PAGE_CHANGED,
  ON_SET_SEARCH_INITIAL_STATE,
  ON_COPY_LINK_CLICK,
  ON_PAGE_SIZE_CHANGE,
  ON_ROW_SELECTION_CHANGE,
  ON_ONE_WORD_SELECTED,
  ON_ONE_PDF_SELECTED,
  ON_SEARCH_BY_CHANGE,
  ON_SHARE_DOCUMENT_CLICK,
  ON_SHARE_LINK_CLICK,
  ON_CHECK_IN_SUCCESS,
  ON_RELEASE_LEVEL_CHANGE,
  ON_ADVANCE_SEARCH_START_DATE_CHANGE,
  ON_ADVANCE_SEARCH_END_DATE_CHANGE,
  ON_ANY_DATE_CHECKED,
  ON_ONLY_WHERE_USER_CHECKED,
  ON_SEARCH_TYPE_CHANGE,
  ON_SEARCH_VALUE_CHANGE,
  ON_CONTEXTUAL_MENU_DETAILS_CLICK,
  ON_CLOSE_MORE_DETAILS_MODAL_CLICK,
  ON_CONTEXTUAL_MENU_COPY_LINK_CLICK,
  ON_CONTEXTUAL_MENU_SHARE_LINK_CLICK,
  ON_CONTEXTUAL_MENU_SHARE_DOCUMENT_CLICK,
  ON_PLATFORM_OPEN_LINK_CHANGE,
  ON_ACTIVE_PAGE_CHANGE,
  ON_ADVANCE_SEARCH_DOC_CLASS_CHANGE,
  ON_ADVANCE_SEARCH_FORMAT_CHANGE,
  ON_COPYLINK_TOGGLE_CHANGE,
  ON_COPYLINK_TOGGLE_CHANGE_DOWNLOADVIEW,
  ON_DOWNLOAD_VIEWTOGGLE_CHANGE,
  ON_GENERATING_COPY_LINKS,
  ON_ONEDRIVE_SETTINGS_CHANGE,
  ON_ONE_DRIVE_TOGGLE_ENABLE_DOWNLOAD_OR_NOT,
  ON_ONE_DRIVE_ALLOW_EDITING_CHECKED,
  POPUP_LINK_SETTING_MODAL,
  ON_ONEDRIVE_TOGGLE_OPEN_IN_REVIEW_MODE_ONLY,
  ON_ONEDRIVE_OPTIONS_DATE_CHANGE,
  ON_ONEDRIVE_OPTIONS__PASSWORD_CHANGE,
  ON_ONEDRIVE_OPTIONS__PEOPLE_SELECTED,
  PEOPLE_PICKER_CONTACTS,
  ON_DIALOG_MENU_OK_BUTTON_CLICK,
  ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
  ON_MESSAGE_BOX_OK_BUTTON_CLICK,
  DOCCLASS_FORMAT_VALUES_FILTERED,
  ON_VIWE_DOCUMENT_WEB,
  ON_ONE_DRIVE_APPLY_BUTTON_DISABLE,
  ON_DOCTITLE_CHANGED,
  ON_WHERE_CLAUSE_CHANGED,
  ON_PIVOT_SELECTEDKEY_CHANGED,
  ON_SELECTEDKEY_LUNAME_CHANGED,
  ON_ATTACHEDDOCINFO_CHANGED,
  ON_VIEWCOPY_DOC_INFO,
  ON_DOCCLASS_CHANGED,
  ON_DOCFORMAT_CHANGED,
  ON_VIEWREQUIRED_CHANGED,
  ON_FORMATREQUIRED_CHANGED,
  ON_OBJCONREQUIRED_CHANGED,
  ON_RESTRICTEDACCESS_CHANGED,
  ON_DOCDOCFORMAT_CHANGED,
  ON_FILEUPLOAD_CHANGE,
  ON_DOC_CHECKIN_TYPE,
  ON_UPLOADEDFILE_COUNT_CHANGED,
  ON_DOCRELEASE_CHANGED,
  ON_DOCDOCFORMATLIST_CHANGED,
  ON_FILETYPES_CHANGED,
  ON_LOGICALUNITLIST_CHANGED,
  ON_REDIRECT_LINKS,
  ON_CREATE_VIEWCOPY_CHANGED,
  ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
  ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS,
  ON_RECENT_OBJECT_SELECTED,
  ON_VIEWCOPYUPLOAD_CHANGE,
  ON_UPLOADEDVIEWCOPY_COUNT_CHANGED,
  ON_SEARCH_LUNAME,
  ON_SEARCH_OBJ_ID,
  ON_ROW_SELECTION_CHANGE_SEARCH_OBJECTS,
  ON_ADV_OBJ_SELECTED,
  ON_RECENT_OBJECTS_CHANGED,
  ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
  ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
  ON_SELECTED_OBJECTS_CHANGED,
  ON_MESSAGE_BOX_OPEN,
  ON_MESSAGE_BOX_INVOKE,
  ON_SEARCH_KEY_REF,
  ON_CHECKIN_NEW_STATUS_CHANGED,
  ON_REVISIONSEARCH_CLICK,
  ON_REVISIONSEARCH_ITEM_SELECT,
  SET_INITIAL_ROW_SELECTION_DETAILS,
  ON_SET_DOCUMENT_INITIAL_STATE,
  ON_CHECKOUT_STATUS,
  ON_NEWREVISION_CHANGED,
  ON_NEWREVISION_CHANGED_WAR_MSG,
  ON_NEWREVISION_TEXT_CHANGED,
  ON_NEWREVISION_OBJCON_CHANGED,
  ON_ADV_OBJ_CON_COLUMNS_CHANGED,
  ON_MRU_KEYNAMES_CHANGED,
  ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED,
  ON_ADV_OBJ_SELECT_COMPLETED,
  ON_VIEWCOPY_UPLOAD_FAILED,
  ON_NEWREVISION_DISABLED,
  ON_ADV_OBJ_RESULTS_STATUS_CHANGED,
  ON_ADV_OBJ_META_DATA_STATUS_CHANGED,
  ON_DOCUMENT_UPLOAD_FAILED,
  FETCH_COPYRIGHT,
  POPUP_DOWNLOAD_VIEW_MODAL,
  ON_POPUP_DOWNLOAD_VIEW_APPLY,
  TOGGLE_SIDEBAR,
  ON_RECENT_OBJECT_SELECTED_DESCRIPTION,
  ON_CLOSE_TEMPLATE_MORE_DETAILS_MODAL_CLICK,
  ON_CONTEXTUAL_MENU_TEMPLATE_DETAILS_CLICK,
  CLICKED_ON_SAME_NAV_ITEM,
  ON_RESET_LANGUAGE,
  GET_USER_INFO,
  GET_TOKEN_INFO,
  GET_TEAMS_CONTEXT,
  ON_ONEDRIVE_DATALOAD,
  ON_OBJECTCONNECTION_DATALOAD,
  ON_CHECKIN_DOCUMENT_PROGRESS,
  ON_CHECKIN_PROGRESS_CHANGED,
  ON_BASIC_DATA_INFO_CHANGED,
  ON_CHECK_IN_TO_IFS_CLICKED,
  ONEDRIVE_DOCUMENT_DOWNLOAD_URL,
  ON_CLEAR_ONEDRIVE_DOCUMENT_DOWNLOAD_URL,
  ON_ONEDRIVE_URL_DOWNLOAD_STATUS,
  ONEDRIVE_DOCUMENT_ID,
  ON_CHECKED_OUT_TO_ME,
  ON_IFS_DOCUMENTS_SELECTED,
  ON_IFS_DOCUMENT_LOAD_CHANGED,
  ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
  ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
  ON_UPLOAD_ONEDRIVE_FILES,
  ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
  ON_DOCUMENT_REVISION_LOAD_CHANGED,
  ON_NO_OF_RECORDS_CHANGED,
  ON_MAIN_COMP_WIDTH_CHANGE,
  ON_DOCUMENT_DOWNLOAD,
  ON_SPINNER_TEXT_CHANGE,
  ON_FILE_TYPE_SELECTED,
  ON_SEARCHED_FILE_TYPE,
  ON_SEARCH,
  ON_SEARCH_RESULT_COUNT_CHANGE,
  ON_SEARCH_Filtered,
  ON_SELECTED_PAGE_INDEX_CHANGE,
  ON_PAGINATION_LOAD,
  ON_ONEDRIVE_FILE_TYPE_SELECTED,
  ONEDRIVE_SEARCH,
  ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
  ONEDRIVE_SEARCH_Filtered,
  ON_FILTER_VISIBILITY,
  ON_ONEDRIVE_FILTER_VISIBILITY,
  ON_NEWREVISION_INFO_CHANGED,
  ON_NEWREVISION_DOC_INFO_CHANGED,
  ON_TOKEN_FAIL,
  ON_DOCUMENT_STORAGE_MODE,
  ON_FILE_ACCESS_STATUS,
  ON_ACCORDION_EXPANDED_CHANGE,
  ON_DELETE_ONEDRIVE_DOCUMENT,
  ON_ALLOW_SELECTION,
  ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
  ON_WORKING_DOCUMENT_MODEL_OPEN,
  ON_WORKING_DOCUMENT_LOAD_STATUS,
  ON_WORKING_IFS_DOCUMENT_CHANGE,
  ON_SELECTED_ONEDRIVE_FILE_CHANGE,
  ON_CHECKIN_EXISTING_STATUS_CHANGE,
  ON_WORKING_DOCUMENT_CHECKIN_TYPE_CHANGE,
  ON_ERROR_MESSAGE_INVOKE,
  ON_EXCEPTION_MESSAGE_INVOKE,
  ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
  ON_IFS_DOCUMENT_DETAILS_MODEL_OPEN,
  ON_CHANNEL_CONFIG_LOAD,
  ON_LOGIN_REFRESH_PREACTION,
  ON_LOGIN_REFRESH_PREACTION_INVOKE,
  ON_IFS_USER_LOAD,
  ON_SERVER_ERROR_MESSAGE_INVOKE,
  ON_WARNING_MESSAGE_INVOKE,
  ON_SUCCESS_MESSAGE_INVOKE,
  ON_WORKING_DOCUMENT_CHANGE,
  ON_CHECKOUT_DOCUMENT_CHANGE,
  ON_SUCCESS_MESSAGE_CLOSE,
  ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
  ON_ATTACHED_DOC_INFO,
  ON_VIEWCOPY_AUTOGENERATE_USER_ADJUSTED
} from "../constants/actionTypes";
import {
  WARNING_TYPE,
  SUCCESS_TYPE,
  DEFAULT_SUCCESS_MESSAGE,
  ERROR_TYPE,
} from "../constants/messageTypes";
import {
  HIDE_SIDE_BAR,
  SMALL_SCREEN_SIZE,
  ON_SEARCH_DISABLE,
  ON_EMPTY_RESULTS,
  ON_CHECKIN_NEW_STATUS,
  PAGE_SIZE_DEFAULT,
  SEARCH_VALUE_DEFAULT,
  SEARCH_BY_DEFAULT,
  ON_REVISION_SEARCH_LOAD,
  ON_ADV_OBJ_MODEL_HIDE,
  ON_ADV_OBJ_RECORD_SELECTED,
  ON_CHECKIN_NEW_PAGE_NAME,
  CHECKIN_NEW_PAGE_NAME,
  IS_TOOL_BAR_DISABLED,
  DATA_LOAD_STATUS,
  DOCUMENT_LOAD_STATUS,
  RESPONSE_TYPE,
  REFRESH_TOKEN_ACTION,
  INVALID_DOCUMENT,
  DEFAULT_REFRESH_TOKEN_ACTION_INVOKED
} from "../constants/metaData";
import { getValidValue } from "../../functions/helperMethod";
import axios from "axios";
import IfsAuth from "../../auth/IfsAuth";
import AuthTeams from "../../auth/AuthTeams";
import OneDriveAuth from "../../auth/OneDriveAuth";
import CustomerConfig from "../../azure/CustomerConfig";
import {
  getFileExtension,
  getFileTypeExtension,
} from "../../functions/helperMethod";
import { getPayloadValue } from "../../functions/reduxMethod";
require("dotenv").config();

let subscriptionKey = new CustomerConfig().getSubscriptionKey();

export const onSelectedPageChange = (pageName) => {
  return {
    type: ON_SELECTED_PAGE_CHANGED,
    payload: pageName,
  };
};

export const onHideSideBar = (isHide) => {
  return {
    type: HIDE_SIDE_BAR,
    payload: !isHide,
  };
};

export const onScreenSizeChange = (isSmallScreen) => {
  return {
    type: SMALL_SCREEN_SIZE,
    payload: isSmallScreen,
  };
};

export const onPageSizeChange = (pageSize) => {
  return {
    type: ON_PAGE_SIZE_CHANGE,
    payload: pageSize,
  };
};

export const onSearchByChange = (searchBy) => {
  return {
    type: ON_SEARCH_BY_CHANGE,
    payload: searchBy,
  };
};

export const onNoOfRecordsChange = (noOfRecords) => {
  return {
    type: ON_NO_OF_RECORDS_CHANGED,
    payload: noOfRecords,
  };
};

export const onCopyLinkClick = (copyLink) => {
  return {
    type: ON_COPY_LINK_CLICK,
    payload: copyLink,
  };
};

export const onShareLinkClick = (shareLink) => {
  return {
    type: ON_SHARE_LINK_CLICK,
    payload: shareLink,
  };
};

export const clickedOnSameNavItem = (isClicked) => {
  return {
    type: CLICKED_ON_SAME_NAV_ITEM,
    payload: isClicked,
  };
};

export const onMainCompWidthChange = (compWidth) => {
  return {
    type: ON_MAIN_COMP_WIDTH_CHANGE,
    payload: compWidth,
  };
};

export const onShareDocumentClick = (shareDocumentLink) => {
  return {
    type: ON_SHARE_DOCUMENT_CLICK,
    payload: shareDocumentLink,
  };
};

export const onTeamsFileSelectionChange = (rowSelection) => {
  return {
    type: ON_ROW_SELECTION_CHANGE,
    payload: rowSelection,
  };
};

export const onRowSelectionChange = (rowSelection) => {
  let selectedWordsCount = 0;
  let selectedPdfCount = 0;
  if (rowSelection && rowSelection.length > 0) {
    for (let item of rowSelection) {
      if (item.fileExtension === "DOC" || item.fileExtension === "DOCX") {
        selectedWordsCount++;
      } else if (item.fileExtension === "PDF") {
        selectedPdfCount++;
      }
    }
    return (dispatch) => {
      dispatch({
        type: ON_ROW_SELECTION_CHANGE,
        payload: rowSelection,
      });
      dispatch({
        type: ON_ONE_WORD_SELECTED,
        payload: selectedWordsCount > 1 ? false : true,
      });
      dispatch({
        type: ON_ONE_PDF_SELECTED,
        payload: selectedPdfCount > 1 ? false : true,
      });
    };
  } else {
    return (dispatch) => {
      dispatch({
        type: ON_ROW_SELECTION_CHANGE,
        payload: rowSelection,
      });
      dispatch({
        type: ON_ONE_WORD_SELECTED,
        payload: selectedWordsCount > 1 ? false : true,
      });
      dispatch({
        type: ON_ONE_PDF_SELECTED,
        payload: selectedPdfCount > 1 ? false : true,
      });
    };
  }
};

export const onIfsDocumentSelectionChange = (rowSelection) => {
  if (rowSelection && rowSelection.length > 0) {
    return (dispatch) => {
      dispatch({
        type: ON_IFS_DOCUMENTS_SELECTED,
        payload: rowSelection,
      });
    };
  } else {
    return (dispatch) => {
      dispatch({
        type: ON_IFS_DOCUMENTS_SELECTED,
        payload: [],
      });
    };
  }
};

export const onContextualMenuDetailsClick = (item) => {
  return {
    type: ON_CONTEXTUAL_MENU_DETAILS_CLICK,
    payload: item,
  };
};

export const onContextualMenuTemplateDetailsClick = (item) => {
  return {
    type: ON_CONTEXTUAL_MENU_TEMPLATE_DETAILS_CLICK,
    payload: item,
  };
};

export const onSearchRevisionClick = (isHide) => {
  return (dispatch) => {
    dispatch({
      type: ON_REVISIONSEARCH_CLICK,
      payload: isHide,
    });
  };
};

export const onAdvObjSearchModelHide = (isHide) => {
  return {
    type: ON_ADV_OBJ_MODEL_HIDE,
    payload: isHide,
  };
};

export const onAdvObjSearchModelSelected = (isSelected) => {
  return {
    type: ON_ADV_OBJ_RECORD_SELECTED,
    payload: isSelected,
  };
};

export const onSelectedRevision = (selectedRows) => {
  let selectedRow =
    selectedRows !== undefined &&
    selectedRows !== null &&
    selectedRows.length > 0
      ? selectedRows[0]
      : [];
  return {
    type: ON_REVISIONSEARCH_ITEM_SELECT,
    payload: selectedRow,
  };
};

export const onContextualMenuCopyLinkClick = (item) => {
  return {
    type: ON_CONTEXTUAL_MENU_COPY_LINK_CLICK,
    payload: item,
  };
};

export const onContextualMenuShareLinkClick = (item) => {
  return {
    type: ON_CONTEXTUAL_MENU_SHARE_LINK_CLICK,
    payload: item,
  };
};

export const onContextualMenuShareDocumentClick = (item) => {
  return {
    type: ON_CONTEXTUAL_MENU_SHARE_DOCUMENT_CLICK,
    payload: item,
  };
};

export const onCloseMoreDetailsModalClick = (state) => {
  return {
    type: ON_CLOSE_MORE_DETAILS_MODAL_CLICK,
    payload: state,
  };
};

export const onCloseTemplateMoreDetailsModalClick = (state) => {
  return {
    type: ON_CLOSE_TEMPLATE_MORE_DETAILS_MODAL_CLICK,
    payload: state,
  };
};

export const onSearchValueChange = (searchValue) => {
  return {
    type: ON_SEARCH_VALUE_CHANGE,
    payload: searchValue,
  };
};

export const onSearchTypeChange = (searchType) => {
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 90);

  return (dispatch) => {
    dispatch({
      type: ON_SEARCH_TYPE_CHANGE,
      payload: searchType,
    });
    dispatch({
      type: ON_ADVANCE_SEARCH_START_DATE_CHANGE,
      payload: startDate,
    });
    dispatch({
      type: ON_ADVANCE_SEARCH_END_DATE_CHANGE,
      payload: new Date(),
    });
  };
};

export const onReleaseLevelChange = (releaseLevel) => {
  return {
    type: ON_RELEASE_LEVEL_CHANGE,
    payload: releaseLevel,
  };
};

export const onAdvanceSearchStartDateChange = (startDate, endDate) => {
  return (dispatch) => {
    dispatch({
      type: ON_ADVANCE_SEARCH_START_DATE_CHANGE,
      payload: startDate,
    });
    dispatch({
      type: ON_ADVANCE_SEARCH_END_DATE_CHANGE,
      payload: endDate,
    });
  };
};

export const onAdvanceSearchEndDateChange = (endDate) => {
  return {
    type: ON_ADVANCE_SEARCH_END_DATE_CHANGE,
    payload: endDate,
  };
};

export const onAnyDateChecked = (state) => {
  return {
    type: ON_ANY_DATE_CHECKED,
    payload: state,
  };
};

export const onOnlyWhereUserInvolvedChecked = (onlyUserInvoved) => {
  return {
    type: ON_ONLY_WHERE_USER_CHECKED,
    payload: onlyUserInvoved,
  };
};

export const onCheckedOutToMe = (checkedOutToMe) => {
  return {
    type: ON_CHECKED_OUT_TO_ME,
    payload: checkedOutToMe,
  };
};

export const onPlatformOpenLinkChange = (platform) => {
  return {
    type: ON_PLATFORM_OPEN_LINK_CHANGE,
    payload: platform,
  };
};

export const onActivePageChange = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: ON_ACTIVE_PAGE_CHANGE,
      payload: currentPage,
    });
    dispatch({
      type: ON_ROW_SELECTION_CHANGE,
      payload: [],
    });
  };
};
export const toggleEditOrView = (toggle) => {
  return {
    type: ON_COPYLINK_TOGGLE_CHANGE,
    payload: toggle,
  };
};

export const toggleDownloadOrView = (toggle) => {
  return {
    type: ON_COPYLINK_TOGGLE_CHANGE_DOWNLOADVIEW,
    payload: toggle,
  };
};

export const toggleViewDownload = (toggle) => {
  return {
    type: ON_DOWNLOAD_VIEWTOGGLE_CHANGE,
    payload: toggle,
  };
};

export const setSpinnerModalOnDownloadingDocuments = (text) => {
  return (dispatch) => {
    dispatch({
      type: ON_SPINNER_TEXT_CHANGE,
      payload: text,
    });
    dispatch({
      type: ON_DOCUMENT_DOWNLOAD,
      payload: true,
    });
  };
};

export const setSpinnerModalOnCheckingDocuments = (text) => {
  return {
    type: ON_VIWE_DOCUMENT_WEB,
    payload: { text: text, state: true },
  };
};

export const SetSpinnerModalOnGeneratingCopyLinks = (text) => {
  return {
    type: ON_GENERATING_COPY_LINKS,
    payload: { text: text, state: true },
  };
};

export const onOneDriveSettingsChange = (item) => {
  return {
    type: ON_ONEDRIVE_SETTINGS_CHANGE,
    payload: item,
  };
};

export const onOneDriveToggleEnableDownloadOrNot = (state) => {
  return {
    type: ON_ONE_DRIVE_TOGGLE_ENABLE_DOWNLOAD_OR_NOT,
    payload: state,
  };
};

export const onOneDriveAllowEditingChecked = (state) => {
  return {
    type: ON_ONE_DRIVE_ALLOW_EDITING_CHECKED,
    payload: state,
  };
};

export const popupLinkSettingModal = (state) => {
  return {
    type: POPUP_LINK_SETTING_MODAL,
    payload: state,
  };
};

export const popupDownloadViewModel = (state) => {
  return {
    type: POPUP_DOWNLOAD_VIEW_MODAL,
    payload: state,
  };
};

export const popupDownloadViewApply = (state) => {
  return {
    type: ON_POPUP_DOWNLOAD_VIEW_APPLY,
    payload: state,
  };
};

export const onOneDriveToggleOpenInReviewModeOnly = (state) => {
  return {
    type: ON_ONEDRIVE_TOGGLE_OPEN_IN_REVIEW_MODE_ONLY,
    payload: state,
  };
};

export const onAdvanceSearchDocClassChange = (docClass, getDocClassFormats) => {
  var result = _getFilterdFormat(docClass, getDocClassFormats);
  var filterdFormats = [];
  filterdFormats.push({ key: "", text: "Any" });
  for (let i = 0; i < result.length; i++) {
    filterdFormats.push({
      key: result[i].FormatSize,
      text: result[i].FormatSizeName,
    });
  }
  return (dispatch) => {
    dispatch({
      type: ON_ADVANCE_SEARCH_DOC_CLASS_CHANGE,
      payload: docClass,
    });
    dispatch({
      type: DOCCLASS_FORMAT_VALUES_FILTERED,
      payload: filterdFormats,
    });
  };
};

function _getFilterdFormat(item, getDocClassFormats) {
  var result = getDocClassFormats.value.filter(
    ({ docClass }) => docClass === item,
  );
  return result;
}

export const onAdvanceSearchFormatChange = (format) => {
  return {
    type: ON_ADVANCE_SEARCH_FORMAT_CHANGE,
    payload: format,
  };
};

export const onDialogOkClick = (state) => {
  return {
    type: ON_DIALOG_MENU_OK_BUTTON_CLICK,
    payload: state,
  };
};

export const onMessageBoxOkClick = (state) => {
  return {
    type: ON_MESSAGE_BOX_OK_BUTTON_CLICK,
    payload: state,
  };
};

export const onMessageBoxMessageChange = (state) => {
  return {
    type: ON_MESSAGE_BOX_INVOKE,
    payload: state,
  };
};

export const onOnedriveOptionsDateChange = (date) => {
  return {
    type: ON_ONEDRIVE_OPTIONS_DATE_CHANGE,
    payload: date,
  };
};

export const onOneDrivePasswordChange = (password) => {
  return {
    type: ON_ONEDRIVE_OPTIONS__PASSWORD_CHANGE,
    payload: password,
  };
};

export const onOneDrivePeopleSelected = (selectedPeople) => {
  return {
    type: ON_ONEDRIVE_OPTIONS__PEOPLE_SELECTED,
    payload: selectedPeople,
  };
};

export const onOneDriveApplyButtonDisable = (state) => {
  return {
    type: ON_ONE_DRIVE_APPLY_BUTTON_DISABLE,
    payload: state,
  };
};

export const peoplePickerContacts = (authChannel) => async (dispatch) => {
  const authAxio = axios.create({
    baseURL: new CustomerConfig().getServiceApi(),
  });

  if (await new IfsAuth().isValidAuthenticated(authChannel)) {
    authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

    const response = await authAxio
      .get(
        "api/get-email-list?email=" + new OneDriveAuth().getOneDriveUserEmail(),
        {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
          },
        },
      )
      .then((res) => {
        dispatch({
          type: PEOPLE_PICKER_CONTACTS,
          payload: res.data,
        });
        return res;
      });
    return response;
  } else {
    new AuthTeams().redirectToLogin();
    return null;
  }
};

export const setSpinnerViewDocumentOnline = (text) => {
  return {
    type: ON_VIWE_DOCUMENT_WEB,
    payload: { text: text, state: true },
  };
};

export const onCheckinNewStatusChange = (status) => {
  return {
    type: ON_CHECKIN_NEW_STATUS_CHANGED,
    payload: status,
  };
};

export const onDocTitleChange = (title) => {
  return {
    type: ON_DOCTITLE_CHANGED,
    payload: title,
  };
};

export const setUserInfo = (userInfo) => {
  return {
    type: GET_USER_INFO,
    payload: userInfo,
  };
};

export const setTokenInfo = (tokenInfo) => {
  return {
    type: GET_TOKEN_INFO,
    payload: tokenInfo,
  };
};

export const setTeamsContex = (teamsContext) => {
  return {
    type: GET_TEAMS_CONTEXT,
    payload: teamsContext,
  };
};

export const onWhereClauseChange = (para) => {
  return {
    type: ON_WHERE_CLAUSE_CHANGED,
    payload: para,
  };
};

export const onPivotSelectedKeyChange = (key) => {
  return (dispatch) => {
    dispatch({
      type: ON_PIVOT_SELECTEDKEY_CHANGED,
      payload: key,
    });
  };
};

export const onAdvObjConColumnsChange = (key) => {
  return (dispatch) => {
    dispatch({
      type: ON_ADV_OBJ_CON_COLUMNS_CHANGED,
      payload: key,
    });
  };
};

export const onMruKeyNamesChange = (key) => {
  return (dispatch) => {
    dispatch({
      type: ON_MRU_KEYNAMES_CHANGED,
      payload: key,
    });
  };
};

export const onAdvObjConSearchResultChange = (key) => {
  return (dispatch) => {
    dispatch({
      type: ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED,
      payload: key,
    });
  };
};

export const onSelectedKeyLuNameChange = (key) => {
  return (dispatch) => {
    dispatch({
      type: ON_SELECTEDKEY_LUNAME_CHANGED,
      payload: key,
    });
  };
};

export const onAttachedDocInfoChange = (docInfo) => {
  return (dispatch) => {
    dispatch({
      type: ON_ATTACHEDDOCINFO_CHANGED,
      payload: docInfo,
    });
  };
};

export const onDocClassChange = (docClass) => {
  return {
    type: ON_DOCCLASS_CHANGED,
    payload: docClass,
  };
};

export const onDocFormatChange = (docFormat) => {
  return {
    type: ON_DOCFORMAT_CHANGED,
    payload: docFormat,
  };
};

export const onDocReleaseChange = (isChecked) => {
  const releaseValue = isChecked ? "Released" : "";
  return {
    type: ON_DOCRELEASE_CHANGED,
    payload: releaseValue,
  };
};

export const onDocClassFormatListChange = (list) => {
  return {
    type: ON_DOCDOCFORMATLIST_CHANGED,
    payload: list,
  };
};

export const onDocFileTypeListChange = (list) => {
  return {
    type: ON_FILETYPES_CHANGED,
    payload: list,
  };
};

export const onLogicalUnitListChange = (list) => {
  return {
    type: ON_LOGICALUNITLIST_CHANGED,
    payload: list,
  };
};

export const onDocClassFormatChange = (
  classCode,
  formatCode,
  viewRequired,
  formatRequired,
  objConRequired,
  uploadFiles,
  uploadViewCopyCount,
  /** @type {{ skipCreateViewCopyDefault?: boolean, restrictedAccess?: string }} */
  options = {},
) => {
  const { skipCreateViewCopyDefault = false } = options ?? {};
  const viewReqYes =
    viewRequired === true ||
    viewRequired === "Y" ||
    viewRequired === "y";
  const viewReqNo =
    viewRequired === false ||
    viewRequired === "N" ||
    viewRequired === "n";

  let classFormat =
    formatCode !== "" ? `${classCode} - ${formatCode}` : classCode;
  let createViewCopy = false;
  if (
    classCode !== "" &&
    uploadFiles !== undefined &&
    uploadFiles !== null &&
    uploadFiles.length > 0
  ) {
    if (
      uploadViewCopyCount !== undefined &&
      uploadViewCopyCount !== null &&
      uploadViewCopyCount > 0
    ) {
      createViewCopy = false;
    } else {
      let ext = uploadFiles[0].name;
      ext = ext.split(".").pop().toUpperCase();
      const isWordLike =
        ext === "DOCX" || ext === "DOC" || ext === "DOCM" || ext === "DOTM";
      createViewCopy = viewReqYes ? isWordLike : false;
    }
  } else if (classCode !== "" && viewReqYes) {
    // Bulk Settings (no file on Redux): auto-enable when class requires view copy.
    createViewCopy = true;
  }
  return (dispatch, getState) => {
    const snap = getState();
    const prevClass = snap?.CheckinDocument?.basicInfo?.docClass ?? "";
    const incomingClass = classCode ?? "";
    const classChanged = incomingClass !== prevClass;
    const restrictedAccess =
      options?.restrictedAccess !== undefined && options?.restrictedAccess !== null
        ? options.restrictedAccess
        : (snap?.CheckinDocument?.basicInfo?.restrictedAccess ?? "N");
    const preserveUserAutoGenerateToggle =
      !classChanged &&
      !!(snap?.CheckinDocument?.checkInForm?.viewCopyAutogenerateUserAdjusted ??
        false);

    if (classChanged) {
      dispatch({
        type: ON_VIEWCOPY_AUTOGENERATE_USER_ADJUSTED,
        payload: false,
      });
    }

    dispatch({
      type: ON_DOCCLASS_CHANGED,
      payload: classCode,
    });
    dispatch({
      type: ON_DOCFORMAT_CHANGED,
      payload: formatCode,
    });
    dispatch({
      type: ON_DOCDOCFORMAT_CHANGED,
      payload: classFormat,
    });
    dispatch({
      type: ON_VIEWREQUIRED_CHANGED,
      payload: viewRequired,
    });
    dispatch({
      type: ON_FORMATREQUIRED_CHANGED,
      payload: formatRequired,
    });
    dispatch({
      type: ON_OBJCONREQUIRED_CHANGED,
      payload: objConRequired,
    });
    dispatch({
      type: ON_RESTRICTEDACCESS_CHANGED,
      payload: restrictedAccess,
    });
    if (!preserveUserAutoGenerateToggle && !skipCreateViewCopyDefault) {
      if (classCode === "") {
        dispatch({
          type: ON_CREATE_VIEWCOPY_CHANGED,
          payload: false,
        });
      } else if (
        (uploadFiles && uploadFiles.length > 0) ||
        viewReqYes ||
        viewReqNo
      ) {
        dispatch({
          type: ON_CREATE_VIEWCOPY_CHANGED,
          payload: createViewCopy,
        });
      }
    }
  };
};

export const onFileDataChange = (files, count) => {
  return (dispatch) => {
    dispatch({
      type: ON_FILEUPLOAD_CHANGE,
      payload: files,
    });
    dispatch({
      type: ON_UPLOADEDFILE_COUNT_CHANGED,
      payload: count,
    });
  };
};

export const onFileUploadChange = (
  files,
  count,
  uploadViewCopyCount,
  viewRequired,
) => {
  let title = count > 0 ? files[0].name : "";
  let ext = count > 0 ? files[0].name : "";
  title = title.replace(/\.[^/.]+$/, "");
  ext = ext.split(".").pop().toUpperCase();
  let isDoc = ext === "DOCX" || ext === "DOC" || ext === "DOCM" || ext === "DOTM";
  let createViewCopy =
    viewRequired === true
      ? uploadViewCopyCount !== undefined &&
        uploadViewCopyCount !== null &&
        uploadViewCopyCount === 0
        ? isDoc
        : false
      : false;
  return (dispatch) => {
    dispatch({
      type: ON_FILEUPLOAD_CHANGE,
      payload: files,
    });
    dispatch({
      type: ON_UPLOADEDFILE_COUNT_CHANGED,
      payload: count,
    });
    dispatch({
      type: ON_DOCTITLE_CHANGED,
      payload: title,
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
      payload: !isDoc,
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_CHANGED,
      payload: createViewCopy,
    });
  };
};

export const onViewCopyUploadChange = (
  files,
  count,
  uploadViewCopyCount,
  viewRequired,
  uploadFiles,
  keepDragnDrop = false,
) => {
  let createViewCopy = false;
  if (
    uploadFiles !== undefined &&
    uploadFiles !== null &&
    uploadFiles.length > 0
  ) {
    let title = uploadFiles[0].name;
    let ext = uploadFiles[0].name;
    title = title.replace(/\.[^/.]+$/, "");
    ext = ext.split(".").pop().toUpperCase();
    let isDoc = ext === "DOCX" || ext === "DOC" || ext === "DOCM" || ext === "DOTM";

    createViewCopy =
      viewRequired === true
        ? uploadViewCopyCount !== undefined &&
          uploadViewCopyCount !== null &&
          uploadViewCopyCount === 0
          ? keepDragnDrop === true
            ? false
            : isDoc
          : false
        : false;
  }
  const shouldUpdateAutoGenerate =
    uploadFiles !== undefined &&
    uploadFiles !== null &&
    uploadFiles.length > 0;

  return (dispatch) => {
    dispatch({
      type: ON_VIEWCOPYUPLOAD_CHANGE,
      payload: files,
    });
    dispatch({
      type: ON_UPLOADEDVIEWCOPY_COUNT_CHANGED,
      payload: count,
    });
    if (shouldUpdateAutoGenerate) {
      dispatch({
        type: ON_CREATE_VIEWCOPY_CHANGED,
        payload: createViewCopy,
      });
    }
  };
};

export const onDocCheckinTypeChange = (type) => {
  return {
    type: ON_DOC_CHECKIN_TYPE,
    payload: type,
  };
};

export const onSearchButtonDisable = (isDiable) => {
  return {
    type: ON_SEARCH_DISABLE,
    payload: isDiable,
  };
};

export const onRedirectLinks = (links) => {
  return {
    type: ON_REDIRECT_LINKS,
    payload: links,
  };
};

export const onCreateViewCopyDisable = (disable) => {
  return {
    type: ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
    payload: disable,
  };
};

export const onCreateViewCopySelect = (selected, options = {}) => {
  const { programmatic = false } = options ?? {};
  return (dispatch) => {
    dispatch({
      type: ON_CREATE_VIEWCOPY_CHANGED,
      payload: selected,
    });
    dispatch({
      type: ON_VIEWCOPY_AUTOGENERATE_USER_ADJUSTED,
      payload: !programmatic,
    });
  };
};

export const onAdvObjRowSelected = (rowSelection) => {
  return (dispatch) => {
    dispatch({
      type: ON_ROW_SELECTION_CHANGE_SEARCH_OBJECTS,
      payload: rowSelection,
    });
  };
};

export const onEmptyResults = (message) => {
  return {
    type: ON_EMPTY_RESULTS,
    payload: message,
  };
};

export const onSearchLuNameChange = (luName, nameDesc, viewName) => {
  return {
    type: ON_SEARCH_LUNAME,
    payload: { luName: luName, nameDesc: nameDesc, viewName: viewName },
  };
};

export const onSearchObjIdChange = (objId) => {
  return {
    type: ON_SEARCH_OBJ_ID,
    payload: objId,
  };
};

export const onRecentObjectConnectionChanged = (objCons) => {
  return {
    type: ON_RECENT_OBJECTS_CHANGED,
    payload: objCons,
  };
};

export const onRecentObjectDataLoadStatusChanged = (objCons) => {
  return {
    type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
    payload: objCons,
  };
};

export const onRecentObjectConnectionSelect = (selectedList) => {
  return {
    type: ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS,
    payload: selectedList,
  };
};

export const onRecentObjectSelected = (selectedList) => {
  return {
    type: ON_RECENT_OBJECT_SELECTED,
    payload: selectedList,
  };
};

export const onRecentObjectSelectedDescription = (nameDesc) => {
  return {
    type: ON_RECENT_OBJECT_SELECTED_DESCRIPTION,
    payload: nameDesc,
  };
};

export const onSelectedObjectConnectionChanged = (
  recentObjects,
  searchObjects,
) => {
  let selectedObj = [];
  if (
    recentObjects !== undefined &&
    recentObjects !== null &&
    recentObjects.length > 0
  ) {
    recentObjects.map((recObj) => {
      selectedObj.push(recObj);
    });
  }

  if (selectedObj.length > 0) {
    if (searchObjects !== undefined && searchObjects !== null) {
      searchObjects.map((obj) => {
        let available = false;
        recentObjects.map((recObj) => {
          if (recObj.keyRef === obj.keyRef && recObj.luName === obj.luName) {
            available = true;
          }
        });
        if (available === false) {
          selectedObj.push(obj);
        }
      });
    }
  } else {
    if (
      searchObjects !== undefined &&
      searchObjects !== null &&
      searchObjects.length > 0
    ) {
      searchObjects.map((recObj) => {
        selectedObj.push(recObj);
      });
    }
  }

  return (dispatch) => {
    dispatch({
      type: ON_SELECTED_OBJECTS_CHANGED,
      payload: selectedObj !== null ? selectedObj.sort() : [],
    });

    dispatch({
      type: ON_RECENT_OBJECT_SELECTED,
      payload:
        recentObjects !== undefined && recentObjects !== null
          ? recentObjects
          : [],
    });

    dispatch({
      type: ON_ADV_OBJ_SELECTED,
      payload:
        searchObjects !== undefined && searchObjects !== null
          ? searchObjects
          : [],
    });

    dispatch({
      type: ON_SEARCH_LUNAME,
      payload: { luName: "", nameDesc: "" },
    });

    dispatch({
      type: ON_SELECTEDKEY_LUNAME_CHANGED,
      payload: "",
    });
  };
};

export const onRefreshSearch = () => {
  return (dispatch) => {
    dispatch({
      type: ON_SET_SEARCH_INITIAL_STATE,
      payload: [],
    });
    dispatch({
      type: ON_SET_DOCUMENT_INITIAL_STATE,
      payload: [],
    });
    dispatch({
      type: ON_PAGE_SIZE_CHANGE,
      payload: PAGE_SIZE_DEFAULT,
    });
    dispatch({
      type: ON_SEARCH_BY_CHANGE,
      payload: SEARCH_BY_DEFAULT,
    });
    dispatch({
      type: SET_INITIAL_ROW_SELECTION_DETAILS,
      payload: [],
    });
    dispatch({
      type: ON_SEARCH_VALUE_CHANGE,
      payload: SEARCH_VALUE_DEFAULT,
    });
    dispatch({
      type: ON_SEARCH_TYPE_CHANGE,
      payload: false,
    });
    dispatch({
      type: ON_CHECKOUT_STATUS,
      payload: "",
    });
  };
};

export const onRefreshCheckinNew = (completeClear) => {
  return (dispatch) => {
    if (completeClear) {
      dispatch({
        type: ON_CHECKIN_NEW_STATUS_CHANGED,
        payload: ON_CHECKIN_NEW_STATUS.refresh,
      });
    } else {
      dispatch({
        type: ON_CHECKIN_NEW_STATUS_CHANGED,
        payload: ON_CHECKIN_NEW_STATUS.tabRefreh,
      });
    }
    dispatch({
      type: ON_DOCTITLE_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_WHERE_CLAUSE_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_SELECTEDKEY_LUNAME_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_DOCDOCFORMAT_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_DOCCLASS_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_VIEWREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_FORMATREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_OBJCONREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_DOCRELEASE_CHANGED,
      payload: false,
    });
    dispatch({
      type: ON_FILEUPLOAD_CHANGE,
      payload: [],
    });

    dispatch({
      type: ON_LOGICALUNITLIST_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_ATTACHEDDOCINFO_CHANGED,
      payload: null,
    });
    dispatch({
      type: ON_VIEWCOPY_DOC_INFO,
      payload: [],
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
      payload: true,
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_CHANGED,
      payload: false,
    });
    dispatch({
      type: ON_VIEWCOPYUPLOAD_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_UPLOADEDVIEWCOPY_COUNT_CHANGED,
      payload: 0,
    });
    dispatch({
      type: ON_SEARCH_LUNAME,
      payload: [],
    });
    dispatch({
      type: ON_SEARCH_OBJ_ID,
      payload: "",
    });
    dispatch({
      type: ON_SEARCH_KEY_REF,
      payload: "",
    });
    dispatch({
      type: ON_RECENT_OBJECTS_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
      payload: DOCUMENT_LOAD_STATUS.onStart,
    });
    dispatch({
      type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
      payload: "",
    });
    dispatch({
      type: ON_SELECTED_OBJECTS_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_PIVOT_SELECTEDKEY_CHANGED,
      payload: "1.1",
    });
    dispatch({
      type: ON_ADV_OBJ_CON_COLUMNS_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_MRU_KEYNAMES_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_RECENT_OBJECT_SELECTED,
      payload: [],
    });
    dispatch({
      type: ON_ADV_OBJ_SELECTED,
      payload: [],
    });
    dispatch({
      type: ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED,
      payload: [],
    });
    dispatch({
      type: ON_ROW_SELECTION_CHANGE_SEARCH_OBJECTS,
      payload: [],
    });
    dispatch({
      type: ON_CHECKIN_NEW_PAGE_NAME,
      payload: CHECKIN_NEW_PAGE_NAME.file,
    });
  };
};

export const onRefreshCheckinNewRevision = (completeClear) => {
  return (dispatch) => {
    if (completeClear) {
      dispatch({
        type: ON_CHECKIN_NEW_STATUS_CHANGED,
        payload: ON_CHECKIN_NEW_STATUS.refresh,
      });
    } else {
      dispatch({
        type: ON_CHECKIN_NEW_STATUS_CHANGED,
        payload: ON_CHECKIN_NEW_STATUS.tabRefreh,
      });
    }
    dispatch({
      type: ON_VIEWREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_FORMATREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_OBJCONREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_FILEUPLOAD_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_UPLOADEDFILE_COUNT_CHANGED,
      payload: 0,
    });
    dispatch({
      type: ON_ATTACHEDDOCINFO_CHANGED,
      payload: null,
    });
    dispatch({
      type: ON_VIEWCOPY_DOC_INFO,
      payload: [],
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
      payload: true,
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_CHANGED,
      payload: false,
    });
    dispatch({
      type: ON_VIEWCOPYUPLOAD_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_UPLOADEDVIEWCOPY_COUNT_CHANGED,
      payload: 0,
    });
    dispatch({
      type: ON_PIVOT_SELECTEDKEY_CHANGED,
      payload: "1.1",
    });
    dispatch({
      type: ON_NEWREVISION_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_NEWREVISION_CHANGED_WAR_MSG,
      payload: "",
    });
    dispatch({
      type: ON_NEWREVISION_TEXT_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_NEWREVISION_OBJCON_CHANGED,
      payload: [],
    });
    dispatch({
      type: SET_INITIAL_ROW_SELECTION_DETAILS,
      payload: [],
    });
    dispatch({
      type: ON_REVISIONSEARCH_ITEM_SELECT,
      payload: [],
    });
  };
};

export const onClearCheckinNewRevision = () => {
  return (dispatch) => {
    dispatch({
      type: ON_VIEWREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_FILEUPLOAD_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_UPLOADEDFILE_COUNT_CHANGED,
      payload: 0,
    });
    dispatch({
      type: ON_VIEWCOPY_DOC_INFO,
      payload: [],
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
      payload: true,
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_CHANGED,
      payload: false,
    });
    dispatch({
      type: ON_VIEWCOPYUPLOAD_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_UPLOADEDVIEWCOPY_COUNT_CHANGED,
      payload: 0,
    });
    dispatch({
      type: ON_NEWREVISION_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_NEWREVISION_CHANGED_WAR_MSG,
      payload: "",
    });
    dispatch({
      type: ON_NEWREVISION_TEXT_CHANGED,
      payload: "",
    });
    dispatch({
      type: ON_NEWREVISION_OBJCON_CHANGED,
      payload: [],
    });
    dispatch({
      type: SET_INITIAL_ROW_SELECTION_DETAILS,
      payload: [],
    });
    dispatch({
      type: ON_REVISIONSEARCH_ITEM_SELECT,
      payload: [],
    });
  };
};

export const onRefreshCheckinExisting = () => {
  return (dispatch) => {
    dispatch({
      type: ON_VIEWREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_FORMATREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_OBJCONREQUIRED_CHANGED,
      payload: "N",
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_ENABLE_CHANGED,
      payload: true,
    });
    dispatch({
      type: ON_CREATE_VIEWCOPY_CHANGED,
      payload: false,
    });
    dispatch({
      type: ON_VIEWCOPYUPLOAD_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_UPLOADEDVIEWCOPY_COUNT_CHANGED,
      payload: 0,
    });
  };
};

export const onBasicValidation =
  (
    viewCopyRequired,
    formatRequired,
    uploadViewCopyCount,
    createViewCopy,
    formatName,
    className,
  ) =>
  (dispatch) => {
    let isValidated = false;

    if (
      viewCopyRequired !== undefined &&
      viewCopyRequired !== null &&
      viewCopyRequired === true
    ) {
      if (uploadViewCopyCount > 0 || createViewCopy === true) {
        isValidated = true;
      } else {
        isValidated = false;
      }
    } else {
      isValidated = true;
    }

    if (isValidated) {
      if (
        formatRequired !== undefined &&
        formatRequired !== null &&
        formatRequired === true
      ) {
        if (
          formatName !== undefined &&
          formatName !== null &&
          formatName !== ""
        ) {
          isValidated = true;
        } else {
          isValidated = false;
        }
      }
    }
    return isValidated;
  };

export const onCheckinValidation =
  (objConRequired, selectedObjectConnections, className) => (dispatch) => {
    let isValidated = false;

    if (
      objConRequired !== undefined &&
      objConRequired !== null &&
      objConRequired === true
    ) {
      if (
        selectedObjectConnections !== undefined &&
        selectedObjectConnections !== null &&
        selectedObjectConnections.length > 0
      ) {
        isValidated = true;
      } else {
        isValidated = false;
      }
    } else {
      isValidated = true;
    }

    return isValidated;
  };

export const onCheckinNewRevisionValidation =
  (viewCopyRequired, uploadViewCopyCount, createViewCopy, className) =>
  (dispatch) => {
    let isValidated = false;

    if (
      viewCopyRequired !== undefined &&
      viewCopyRequired !== null &&
      viewCopyRequired === true
    ) {
      if (uploadViewCopyCount > 0 || createViewCopy === true) {
        isValidated = true;
      } else {
        isValidated = false;
      }
    } else {
      isValidated = true;
    }
    return isValidated;
  };

export const onCheckoutDocumentValidation =
  (selectedIfsDocuments, checkoutDocumentList) => (dispatch) => {
    let isValidated = false;
    let messageBox = {
      type: WARNING_TYPE,
      message: "Validation Failed",
      errorMessage: "",
      error: null,
    };
    if (
      selectedIfsDocuments !== undefined &&
      selectedIfsDocuments !== null &&
      checkoutDocumentList !== undefined &&
      checkoutDocumentList !== null
    ) {
      if (checkoutDocumentList.length > 0) {
        if (selectedIfsDocuments.length > checkoutDocumentList.length) {
          messageBox.message = `Only documents with a checked-in status will proceed to check out.`;
          dispatch({
            type: ON_MESSAGE_BOX_INVOKE,
            payload: messageBox,
          });
          dispatch({
            type: ON_MESSAGE_BOX_OPEN,
            payload: true,
          });
        }
        isValidated = true;
      } else {
        messageBox.message = `Please select a checked-in document to proceed with the check-out.`;
        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
      }
    }

    return isValidated;
  };

export const onNewRevisionChange = (newRevision) => {
  return {
    type: ON_NEWREVISION_CHANGED,
    payload: newRevision,
  };
};

export const onNewRevisionChangeWarMsg = (warMsg) => {
  return {
    type: ON_NEWREVISION_CHANGED_WAR_MSG,
    payload: warMsg,
  };
};

export const onNewRevisionTextChange = (text) => {
  return {
    type: ON_NEWREVISION_TEXT_CHANGED,
    payload: text,
  };
};

export const onNewRevisionObjConChange = (objCons) => {
  return {
    type: ON_NEWREVISION_OBJCON_CHANGED,
    payload: objCons,
  };
};

export const onRevisionSearchLoadOn = (isLoad) => {
  return {
    type: ON_REVISION_SEARCH_LOAD,
    payload: isLoad,
  };
};

export const onCreateViewCopyChange = (value) => ({
  type: "ON_CREATE_VIEWCOPY_CHANGED",
  payload: value,
});

export const onAdvObjCompeleted = (isCompleted) => {
  return {
    type: ON_ADV_OBJ_SELECT_COMPLETED,
    payload: isCompleted,
  };
};

export const onViewCopyUploadFail = (isFailed) => {
  return {
    type: ON_VIEWCOPY_UPLOAD_FAILED,
    payload: isFailed,
  };
};

export const onNewRevisionDisabled = (isDisable) => {
  return {
    type: ON_NEWREVISION_DISABLED,
    payload: isDisable,
  };
};

export const onAdvObjResultsStatusChanged = (status) => {
  return {
    type: ON_ADV_OBJ_RESULTS_STATUS_CHANGED,
    payload: status,
  };
};

export const onAdvObjMetaDataStatusChanged = (status) => {
  return {
    type: ON_ADV_OBJ_META_DATA_STATUS_CHANGED,
    payload: status,
  };
};

export const onDocumentUploadFailed = (failed) => {
  return {
    type: ON_DOCUMENT_UPLOAD_FAILED,
    payload: failed,
  };
};

export const fetchCopyRight = (copyRight) => {
  return {
    type: FETCH_COPYRIGHT,
    payload: copyRight,
  };
};

export const onResetLangauage = (pageLoadLanguage) => {
  return {
    type: ON_RESET_LANGUAGE,
    payload: pageLoadLanguage,
  };
};

export const toggleSideBar = (toggleSideBar) => {
  return {
    type: TOGGLE_SIDEBAR,
    payload: toggleSideBar,
  };
};

export const onCheckInToIFSClicked = (isCheckInToIFSClicked) => {
  return {
    type: ON_CHECK_IN_TO_IFS_CLICKED,
    payload: isCheckInToIFSClicked,
  };
};

export const onClearOneDriveDownloadUrl = (shouldClearUrl) => {
  return {
    type: ON_CLEAR_ONEDRIVE_DOCUMENT_DOWNLOAD_URL,
    payload: shouldClearUrl,
  };
};

export const onCheckinPageNameChanged = (name) => {
  return {
    type: ON_CHECKIN_NEW_PAGE_NAME,
    payload: name,
  };
};

export const onCheckInSuccess = (checkIn) => {
  return {
    type: ON_CHECK_IN_SUCCESS,
    payload: checkIn,
  };
};

export const onSucessDialogOkClick = (state) => {
  return (dispatch) => {
    dispatch({
      type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
      payload: state,
    });
    dispatch({
      type: ON_ROW_SELECTION_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_ONE_WORD_SELECTED,
      payload: IS_TOOL_BAR_DISABLED,
    });
    dispatch({
      type: ON_ONE_PDF_SELECTED,
      payload: IS_TOOL_BAR_DISABLED,
    });
    dispatch({
      type: ON_ATTACHEDDOCINFO_CHANGED,
      payload: null,
    });
  };
};

export const onOneDriveDataLoad = (status) => {
  return {
    type: ON_ONEDRIVE_DATALOAD,
    payload: status,
  };
};

export const onObjectConnectionDataLoad = (status) => {
  return {
    type: ON_OBJECTCONNECTION_DATALOAD,
    payload: status,
  };
};

export const onCheckinDocumentProgress = (status) => {
  return {
    type: ON_CHECKIN_DOCUMENT_PROGRESS,
    payload: status,
  };
};

export const onCheckinProgressChange = (status) => {
  return {
    type: ON_CHECKIN_PROGRESS_CHANGED,
    payload: status,
  };
};

export const onBasicDataProgressChange = (status) => {
  return {
    type: ON_BASIC_DATA_INFO_CHANGED,
    payload: status,
  };
};

export const onOneDriveUrlDownloadStatusChange = (status) => {
  return {
    type: ON_ONEDRIVE_URL_DOWNLOAD_STATUS,
    payload: status,
  };
};

export const onOneDriveDocumentIdChange = (Id) => {
  return {
    type: ONEDRIVE_DOCUMENT_ID,
    payload: Id,
  };
};

export const onOneDriveDocumentDownloadUrlChange = (url) => {
  return {
    type: ONEDRIVE_DOCUMENT_DOWNLOAD_URL,
    payload: url,
  };
};

export const onIfsDocumentLoadChange = (status) => {
  return {
    type: ON_IFS_DOCUMENT_LOAD_CHANGED,
    payload: status,
  };
};

export const onIfsDocumentBackgroundLoadChange = (status) => {
  return {
    type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
    payload: status,
  };
};

export const onOneDriveDocumentBackgroundLoadChange = (status) => {
  return {
    type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
    payload: status,
  };
};

export const onDocumentRevisionLoadChange = (status) => {
  return {
    type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
    payload: status,
  };
};

export const onDocumentLoadChange = (status) => {
  return {
    type: ON_IFS_DOCUMENT_LOAD_CHANGED,
    payload: status,
  };
};

export const onUploadOneDriveFilesChanged = (files) => {
  return {
    type: ON_UPLOAD_ONEDRIVE_FILES,
    payload: files,
  };
};

export const onUploadOneDriveStatusChanged = (ststus) => {
  return {
    type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
    payload: ststus,
  };
};

export const FILTER_DOCUMENTS = "FILTER_DOCUMENTS";

export const filterDocuments = (activeButton) => ({
  type: FILTER_DOCUMENTS,
  payload: activeButton,
});

export const onFileTypeSelection = (fileType) => {
  return {
    type: ON_FILE_TYPE_SELECTED,
    payload: fileType,
  };
};

export const onFileAccessStatus = (fileType) => {
  return {
    type: ON_FILE_ACCESS_STATUS,
    payload: fileType,
  };
};

export const onSearchedFileType = (fileType) => {
  return {
    type: ON_SEARCHED_FILE_TYPE,
    payload: fileType,
  };
};

export const onFileTypeChanged = (
  searchData,
  fileType,
  pageSize,
  loadIFSDocument,
) => {
  let filterDocuments = [];
  if (fileType !== undefined && fileType !== null && fileType !== "") {
    if (
      searchData !== undefined &&
      searchData !== null &&
      searchData.length > 0
    ) {
      searchData.map((item) => {
        if (item.FileExtension.toUpperCase() === fileType) {
          filterDocuments.push(item);
        }
      });
    }
  } else {
    filterDocuments = searchData;
  }

  let data = {
    value:
      filterDocuments === undefined
        ? []
        : filterDocuments === null
          ? []
          : filterDocuments,
  };
  let pageIndex = 0;
  let loadIFSDocumentStatus =
    loadIFSDocument !== DATA_LOAD_STATUS.onLoad
      ? data.value.length > 0
        ? DATA_LOAD_STATUS.completed
        : DATA_LOAD_STATUS.noDate
      : loadIFSDocument;
  return (dispatch) => {
    dispatch({
      type: ON_SEARCH,
      payload: data,
    });
    dispatch({
      type: ON_SEARCH_RESULT_COUNT_CHANGE,
      payload: data,
    });
    dispatch({
      type: ON_SELECTED_PAGE_INDEX_CHANGE,
      payload: pageIndex,
    });
    let skippedRows = pageIndex * pageSize;

    let filteredDocuments = {
      value:
        data.value != null
          ? data.value.slice(skippedRows, skippedRows + pageSize)
          : null,
    };
    dispatch({
      type: ON_SEARCH_Filtered,
      payload: filteredDocuments,
    });
    dispatch({
      type: ON_PAGINATION_LOAD,
      payload: DATA_LOAD_STATUS.onLoad,
    });
    dispatch({
      type: ON_IFS_DOCUMENT_LOAD_CHANGED,
      payload: loadIFSDocumentStatus,
    });
  };
};

export const onOneDriveFileTypeChanged = (
  searchData,
  fileType,
  pageSize,
  oneDriveDataLoad,
) => {
  let filterDocuments = [];
  if (fileType !== undefined && fileType !== null && fileType !== "") {
    if (
      searchData !== undefined &&
      searchData !== null &&
      searchData.length > 0
    ) {
      searchData.map((item) => {
        let ext = getFileExtension(item.name);
        if (ext.toUpperCase() === getFileTypeExtension(fileType)) {
          filterDocuments.push(item);
        }
      });
    }
  } else {
    filterDocuments = searchData;
  }
  let data = {
    value: filterDocuments,
  };
  let pageIndex = 0;
  let loadOneDriveDocumentStatus =
    oneDriveDataLoad !== DATA_LOAD_STATUS.onLoad
      ? data.value.length > 0
        ? DATA_LOAD_STATUS.completed
        : DATA_LOAD_STATUS.noDate
      : oneDriveDataLoad;
  return (dispatch) => {
    dispatch({
      type: ONEDRIVE_SEARCH,
      payload: data,
    });
    dispatch({
      type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
      payload: data,
    });
    dispatch({
      type: ON_SELECTED_PAGE_INDEX_CHANGE,
      payload: pageIndex,
    });
    let skippedRows = pageIndex * pageSize;

    let filteredDocuments = {
      value:
        data.value != null
          ? data.value.slice(skippedRows, skippedRows + pageSize)
          : null,
    };
    dispatch({
      type: ONEDRIVE_SEARCH_Filtered,
      payload: filteredDocuments,
    });
    dispatch({
      type: ON_PAGINATION_LOAD,
      payload: DATA_LOAD_STATUS.onLoad,
    });
    dispatch({
      type: ON_ONEDRIVE_DATALOAD,
      payload: loadOneDriveDocumentStatus,
    });
  };
};

export const onOneDriveFileTypeSelection = (fileType) => {
  return {
    type: ON_ONEDRIVE_FILE_TYPE_SELECTED,
    payload: fileType,
  };
};

// In your redux/slices/toolsAction.js file
export const SET_ACTIVE_BUTTON = "SET_ACTIVE_BUTTON";

export const onPaginationLoad = (status) => {
  return {
    type: ON_PAGINATION_LOAD,
    payload: status,
  };
};

export const setActiveButton = (activeButton) => {
  return {
    type: SET_ACTIVE_BUTTON,
    payload: activeButton,
  };
};

export const onFilterVisibilityChange = (isVisible) => {
  return {
    type: ON_FILTER_VISIBILITY,
    payload: isVisible,
  };
};

export const onOneDriveFilterVisibilityChange = (isVisible) => {
  return {
    type: ON_ONEDRIVE_FILTER_VISIBILITY,
    payload: isVisible,
  };
};

export const onNewRevisionInfoChange = (status) => {
  return {
    type: ON_NEWREVISION_INFO_CHANGED,
    payload: status,
  };
};

export const onNewRevisionDocInfoChange = (docInfo) => {
  return {
    type: ON_NEWREVISION_DOC_INFO_CHANGED,
    payload: docInfo,
  };
};

export const onTokenAccessFailed = (failed) => {
  return {
    type: ON_TOKEN_FAIL,
    payload: failed,
  };
};

export const onDocumentStorageModeChange = (documentMode) => {
  return {
    type: ON_DOCUMENT_STORAGE_MODE,
    payload: documentMode,
  };
};

export const setAccordionExpandedPanel = (panel) => ({
  type: ON_ACCORDION_EXPANDED_CHANGE,
  payload: panel,
});

export const onSetDocumentToDeleteOneDrive = (docInfo) => {
  return {
    type: ON_DELETE_ONEDRIVE_DOCUMENT,
    payload: docInfo,
  };
};

export const onAllowSelectionChange = (isAllow) => {
  return {
    type: ON_ALLOW_SELECTION,
    payload: isAllow,
  };
};

export const onWorkingDocumentModelTrigger = (open) => {
  return {
    type: ON_WORKING_DOCUMENT_MODEL_OPEN,
    payload: open,
  };
};

export const onIfsDocumentDetailsModelTrigger = (open) => {
  return {
    type: ON_IFS_DOCUMENT_DETAILS_MODEL_OPEN,
    payload: open,
  };
};

export const onWorkingDocumentStatusChange = (status) => {
  return {
    type: ON_WORKING_DOCUMENT_LOAD_STATUS,
    payload: status,
  };
};

export const onIfsDocumentDetailsStatusChange = (status) => {
  return {
    type: ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
    payload: status,
  };
};

export const onWorkingDocumentListStatusChange = (status) => {
  return {
    type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
    payload: status,
  };
};

export const onWorkingIfsDocumentChange = (document) => {
  return {
    type: ON_WORKING_IFS_DOCUMENT_CHANGE,
    payload: document,
  };
};

export const onOneDriveFileSelectionChange = (file) => {
  return {
    type: ON_SELECTED_ONEDRIVE_FILE_CHANGE,
    payload: file,
  };
};

export const onCheckinExistingStatusChange = (status) => {
  return {
    type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
    payload: status,
  };
};

export const onWorkingDocumentCheckinTypeChange = (status) => {
  return {
    type: ON_WORKING_DOCUMENT_CHECKIN_TYPE_CHANGE,
    payload: status,
  };
};

export const onChannelConfigurationLoad = (status) => {
  return {
    type: ON_CHANNEL_CONFIG_LOAD,
    payload: status,
  };
};

export const onLoginRefreshPreActionLoad = (preAction) => {
  return {
    type: ON_LOGIN_REFRESH_PREACTION,
    payload: preAction,
  };
};

export const onLoginRefreshPreActionInvokeLoad = (preAction) => {
  return {
    type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
    payload: preAction,
  };
};

export const onLoginRefreshPreActionClear = () => {
  return (dispatch) => {
    dispatch({
      type: ON_LOGIN_REFRESH_PREACTION,
      payload: {
        retry: 0,
        actionType: REFRESH_TOKEN_ACTION.none,
      },
    });
    dispatch({
      type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
      payload: {
        retry: 0,
        actionType: REFRESH_TOKEN_ACTION.none,
        refreshResponse: RESPONSE_TYPE.none,
      },
    });
  };
};

export const onIFSUserLoad = (status) => {
  return {
    type: ON_IFS_USER_LOAD,
    payload: status,
  };
};

export const onServerErrorMessageInvoke = (status) => {
  return {
    type: ON_SERVER_ERROR_MESSAGE_INVOKE,
    payload: status,
  };
};

export const onExceptionMessageInvoke = (exception) => {
  return {
    type: ON_EXCEPTION_MESSAGE_INVOKE,
    payload: exception,
  };
};

export const onSuccessMessageInvoke = (success) => {
  return {
    type: ON_SUCCESS_MESSAGE_INVOKE,
    payload: getPayloadValue(success, DEFAULT_SUCCESS_MESSAGE),
  };
};

export const onSuccessMessageClose = () => {
  return {
    type: ON_SUCCESS_MESSAGE_CLOSE,
    payload: false,
  };
};

export const onWarningMessageInvoke = (warning) => {
  return {
    type: ON_WARNING_MESSAGE_INVOKE,
    payload: warning,
  };
};

export const onErrorMessageInvoke = (message) => {
  return {
    type: ON_ERROR_MESSAGE_INVOKE,
    payload: message,
  };
};

export const onWorkingDocumentChange = (document) => {
  return {
    type: ON_WORKING_DOCUMENT_CHANGE,
    payload: document,
  };
};

export const onCheckoutDocumentChange = (document) => {
  return {
    type: ON_CHECKOUT_DOCUMENT_CHANGE,
    payload: document,
  };
};

export const onCheckinNewRevisionStatusChange = (status) => {
  return {
    type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
    payload: status,
  };
};

export const onCheckinNewErrorTrigger = (message) => {
  return (dispatch) => {
    let messageBox = {
      type: ERROR_TYPE,
      message: message,
    };
    dispatch({
      type: ON_ERROR_MESSAGE_INVOKE,
      payload: messageBox,
    });
    dispatch({
      type: ON_VIWE_DOCUMENT_WEB,
      payload: { text: "", state: false },
    });
    dispatch({
      type: ON_ATTACHED_DOC_INFO,
      payload: INVALID_DOCUMENT,
    });
    dispatch({
      type: ON_LOGIN_REFRESH_PREACTION,
      payload: {
        retry: 0,
        actionType: REFRESH_TOKEN_ACTION.none,
      },
    });
    dispatch({
      type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
      payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
    });
    dispatch({
      type: ON_CHECKIN_DOCUMENT_PROGRESS,
      payload: DOCUMENT_LOAD_STATUS.onError,
    });
    dispatch({
      type: ON_DOCUMENT_DOWNLOAD,
      payload: false,
    });
  };
};
